import React, { Children, ReactNode } from 'react';

interface ComponentProps {
  title?: string;
  children: ReactNode;
}

const SummaryStatCluster: React.FC<ComponentProps> = ({ title, children }) => {
  return (
    <div className="cluster-container flex-grow-1">
      {title && <div className="cluster-title">{title}</div>}
      <div className="d-flex flex-wrap gap-4 mt-3">
        {Children.map(children, (child) => (
          <div className="flex-grow-1">{child}</div>
        ))}
      </div>
    </div>
  );
};

export default SummaryStatCluster;
